import React from 'react';
import * as _ from 'lodash';
// import { SchaduleBar } from '../../components/gagebar/bar';
import Tippy from '../ReactTippy';
import {
  APPROVED_STATUS,
  PRIVATE_PARTNER_COMPANY_LABEL,
} from '../../utilities/constants';
import {
  getGateFleetStatusName,
  isStatusAcceptGateFutral,
  isStatusRejectGateFutral,
  getMessageGateForTooltip,
} from '../../utilities/gatePassageUtil';
// import { APPROVED_STATUS, USER_ROLES } from '../../utilities/constants';
// import { isTargetRoleId } from '../../utilities/roleUtility';

export const GatePassagesContents = ({
  gate,
  selectedGroup,
  isSelected,
  callbacks,
  isConferenceMode,
  userRollId,
  scheduleLimitTimes,
  disabledTimes,
  viewOnlyFlag,
  isTimeBarReset,
  useConstructionSiteCodeFlg,
  onToggleApprovalSingle,
}) => (
  <tbody id={`group-${gate.id}`} className='table__group show'>
    <tr
      className='table-section-header'
      style={{ borderTop: '1px solid #7C7C7C' }}
    >
      {!isConferenceMode && (
        <td className='data-table__cell'>
          <div className='value-table__icon'>
            <div className='btn-checkbox'>
              <label htmlFor={`btn-checkbox-group-${gate.id}-all`}>
                <input
                  id={`btn-checkbox-group-${gate.id}-all`}
                  className=''
                  type='checkbox'
                  checked={selectedGroup || false}
                  onChange={() =>
                    callbacks.handleSelectedGroup(!selectedGroup, gate.id)
                  }
                />
                <i className='i-square i-3x' />
              </label>
            </div>
          </div>
        </td>
      )}
      <td
        colSpan={useConstructionSiteCodeFlg ? '10' : '8'}
        style={{ padding: 0, boxSizing: 'content-box' }}
      >
        <div
          className='table-section-header__title'
          style={{
            padding: isConferenceMode ? '0 20px' : '4px 0',
          }}
        >
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={renderTooltipContent(gate.name)}
          >
            <span className='table-section-header__content'>{gate.name}</span>
          </Tippy>
          {gate.gate_width ? (
            <span className='table-section-header__width'>
              {`幅:${gate.gate_width}`}
            </span>
          ) : null}
          {gate.gate_height ? (
            <span className='table-section-header__height'>
              {`高さ:${gate.gate_height}`}
            </span>
          ) : null}
        </div>
      </td>
    </tr>
    {_.map(gate.children, gate_passage => (
      <GatePassage
        key={gate_passage.id}
        gateId={gate.id}
        data={gate_passage}
        selected={isSelected(gate.id, gate_passage.id)}
        handleSelectedRow={callbacks.handleSelectedRow}
        handleEdit={callbacks.edit}
        handleGageUpdate={callbacks.handleGageUpdate}
        handleOpenVehicleNumberDialog={callbacks.handleOpenVehicleNumberDialog}
        isConferenceMode={isConferenceMode}
        craneEdit={callbacks.craneEdit}
        userRollId={userRollId}
        scheduleLimitTimes={scheduleLimitTimes}
        disabledTimes={disabledTimes}
        viewOnlyFlag={viewOnlyFlag}
        isTimeBarReset={isTimeBarReset}
        onToggleApprovalSingle={onToggleApprovalSingle}
        useConstructionSiteCodeFlg={useConstructionSiteCodeFlg}
      />
    ))}
    <tr
      className='see-more'
      style={
        gate.childrenLoaded ? { display: 'none' } : { display: 'table-row' }
      }
    >
      <td colSpan='8'>
        <button
          className='see-more__button see-more__button__blue'
          onClick={() => callbacks.handleSeeMore(gate.id)}
        >
          <i className='see-more__button__icon' />
          <p className='see-more__button__text'>さらに表示する</p>
        </button>
      </td>
    </tr>
  </tbody>
);

const renderCompanyName = data => {
  if (!data.spot_company_flag) {
    let betto_label = '';
    if (data.private_partner_company_flag === 1) {
      betto_label = PRIVATE_PARTNER_COMPANY_LABEL;
    }
    switch (data.nest_no) {
      case 1:
        return (
          <React.Fragment>
            {data.company_name_1}{betto_label}
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_2}){betto_label}
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_3}){betto_label}
          </React.Fragment>
        );
      case 4:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_4}){betto_label}
          </React.Fragment>
        );
      case 5:
        return (
          <React.Fragment>
            {data.company_name_1}
            <br />({data.company_name_5}){betto_label}
          </React.Fragment>
        );
      default:
        return data.company_name;
    }
  } else {
    return `${data.spot_company_name}`;
  }
};

const renderCompanyNameTableCell = data => {
  if (!data.spot_company_flag) {
    let betto_label = '';
    if (data.private_partner_company_flag === 1) {
      betto_label = PRIVATE_PARTNER_COMPANY_LABEL;
    }
    switch (data.nest_no) {
      case 1:
        return (
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.company_name_1}{betto_label}
          </span>
        );
      case 2:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_2}){betto_label}
            </span>
          </div>
        );
      case 3:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_3}){betto_label}
            </span>
          </div>
        );
      case 4:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_4}){betto_label}
            </span>
          </div>
        );
      case 5:
        return (
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line'>
              {data.company_name_1}
            </span>
            <span className='data-table__text-wrap-line'>
              ({data.company_name_5}){betto_label}
            </span>
          </div>
        );
      default:
        return (
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.company_name}
          </span>
        );
    }
  } else {
    return (
      <span className='data-table__text-wrap data-table__text-wrap--overflow'>
        {data.spot_company_name}
      </span>
    );
  }
};

const GatePassage = ({
  craneEdit,
  data,
  gateId,
  handleSelectedRow,
  handleEdit,
  handleOpenVehicleNumberDialog,
  isConferenceMode,
  selected,
  onToggleApprovalSingle,
  useConstructionSiteCodeFlg,
}) => (
  <tr
    className='data-table__item data-table__item--clickable'
    onMouseUp={e => handleEdit(e, data)}
  >
    {!isConferenceMode && (
      <React.Fragment>
        <td className='data-table__cell' data-unlink>
          <div className='btn-checkbox'>
            <label htmlFor={`btn-checkbox-group-${data.id}`}>
              <input
                id={`btn-checkbox-group-${data.id}`}
                className='sys-btn-checkbox'
                type='checkbox'
                value={data.id}
                checked={selected}
                onChange={e => handleSelectedRow(e, gateId, !selected)}
              />
              <i className='i-square i-3x' />
            </label>
          </div>
        </td>
        {/* 日付 */}
        <td className='data-table__cell data-table__cell--minimum' data-unlink>
          <div className='data-table__content'>
            {data.passage_date.slice(5)}
          </div>
        </td>
        {/* ステータス */}
        <td
          className={`data-table__cell data-table__cell--minimum${
            useConstructionSiteCodeFlg ? ' data-table__cell--approval' : ''
          }`}
          data-unlink
        >
          <button
            className={
              data.approval_flag
                ? 'status-ticket--large conf-status-ticket'
                : 'status-ticket--caution--large conf-status-ticket'
            }
            onClick={() => onToggleApprovalSingle(data)}
          >
            {data.approval_flag
              ? APPROVED_STATUS.approved.name
              : APPROVED_STATUS.unapproved.name}
          </button>
        </td>
      </React.Fragment>
    )}
    {/* 受付No */}
    <td className='data-table__cell data-table__cell--minimum'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.today_receipt_no)}
      >
        <div className='data-table__content'>{data.today_receipt_no}</div>
      </Tippy>
    </td>
    {useConstructionSiteCodeFlg && (
      <React.Fragment>
        {/* 受諾状態 */}
        <td className='data-table__cell data-table__cell--minimum'>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={renderTooltipContent(getMessageGateForTooltip(data))}
          >
            <div
              className={`data-table__content ${
                isStatusRejectGateFutral(data.gate_fleet_status)
                  ? 'text--negative'
                  : ''
              }`}
            >
              {getGateFleetStatusName(data.gate_fleet_status)}
            </div>
          </Tippy>
        </td>
        {/* 車両番号登録 */}
        <td className='data-table__cell data-table__cell--minimum' data-unlink>
          <div className='data-table__content data-table__content--truck'>
            <span
              className={`data-table__content--truck-total ${
                isStatusAcceptGateFutral(data.gate_fleet_status) &&
                _.isEqual(data.vehicle_total, 0)
                  ? 'text--negative'
                  : ''
              }`}
            >
              {`${data.vehicle_total}/${data.truck_count}台`}
            </span>
            <button
              className='btn--sub'
              onClick={() => handleOpenVehicleNumberDialog(data)}
            >
              車両編集
            </button>
          </div>
        </td>
      </React.Fragment>
    )}
    {/* 車両手配業者 */}
    <td className='data-table__cell data-table__cell--md'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(renderCompanyName(data))}
      >
        <div
          className={`data-table__content ${
            data.spot_company_name ? 'show-shrink' : ''
          }`}
        >
          {renderCompanyNameTableCell(data)}
        </div>
      </Tippy>
    </td>
    {/* 車両/台数/荷種 */}
    <td className='data-table__cell data-table__cell--xl'>
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(
          `${data.truck_name.length > 0 ? data.truck_name : '—'}/${
            data.truck_count
          }台/${data.luggage}`
        )}
      >
        <div className='data-table__content'>
          <div className='data-table__text-wrap'>
            <span className='data-table__text-wrap-line data-table__text-wrap-line--truck'>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  overflow: 'hidden',
                  width: '100%',
                }}
              >
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: isConferenceMode ? '6em' : 'initial',
                  }}
                >
                  {data.truck_name.length > 0 ? data.truck_name : '—'}
                </span>
                <span>/{data.truck_count}台</span>
              </div>
            </span>
            <span className='data-table__text-wrap-line data-table__text-wrap-line--luggage'>
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: isConferenceMode ? '8em' : 'initial',
                }}
              >
                {data.luggage}
              </span>
            </span>
          </div>
        </div>
      </Tippy>
    </td>
    {/* 元請担当者 */}
    <td
      className={
        isConferenceMode
          ? 'data-table__cell data-table__cell--sm'
          : 'data-table__cell data-table__cell--md'
      }
    >
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(
          `${data.manager_user_name_sei} ${data.manager_user_name_mei}`
        )}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {`${data.manager_user_name_sei ? data.manager_user_name_sei : ''} ${
              data.manager_user_name_mei ? data.manager_user_name_mei : ''
            }`}
          </span>
        </div>
      </Tippy>
    </td>
    {/* 備考 */}
    <td
      className={
        isConferenceMode
          ? 'data-table__cell data-table__cell--min-6'
          : 'data-table__cell data-table__cell--lg data-table__cell--min-10'
      }
    >
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.memo)}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.memo}
          </span>
        </div>
      </Tippy>
    </td>
    {/* 楊重機予定 */}
    <td
      className={
        isConferenceMode
          ? 'data-table__cell data-table__cell--sm'
          : 'data-table__cell data-table__cell--lg'
      }
      onClick={e => craneEdit(e, data)}
    >
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        html={renderTooltipContent(data.crane_name)}
      >
        <div className='data-table__content'>
          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
            {data.crane_name}
          </span>
        </div>
      </Tippy>
    </td>
    {/* {isConferenceMode && (
      <td className='data-table__cell' style={{ padding: 0 }}>
        <SchaduleBar
          useStartTime={data.passage_start_time}
          useEndTime={data.passage_end_time}
          spotFlag={data.spot_flag}
          data={data}
          callback={handleGageUpdate}
          isForeman={isTargetRoleId([USER_ROLES.foreman], userRollId)}
          isGate={true}
          scheduleLimitTimes={scheduleLimitTimes}
          disabledTimes={disabledTimes}
          viewOnlyFlag={viewOnlyFlag}
          isTimeBarReset={isTimeBarReset}
        />
      </td>
    )} */}
    <td data-unlink className='data-table__gage-bg' />
  </tr>
);

/**
 * Tooltip
 * @param data {string}
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '300px', //500文字程度入るように
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/GatePassages.jsx